// import Backbone from 'backbone';
import tmpl from '../../templates';
import Sku from '../../models/sku';
import namespace from '../../../upi/namespace';
import {Corpus} from '@modules/lazy-imports';

var app = namespace( 'apps.productpage' );

var ProductImageModuleView = Backbone.View.extend( {

    el: '#productImageWrapper',

    template: _.template( tmpl.productImageModule ),

    initialize: async function ( opt ) {
        this.activeSku = opt.sku;

        await Corpus();
        this.listenTo( this.collection, 'reset', this.render, this );
        this.listenTo( this.activeSku, 'change:id', this.render );
        this.listenTo( app.mediator, 'set:sku', this.setSku );

        if ( this.collection.models.length ) {
            this.render();
        }
    },

    setSku: function ( sku ) {
        sku = sku || new Sku;
        this.activeSku.set( sku.attributes );
    },

    didMount: function () {
        $( this.$el ).corpus( 'tabs carousel' );
    },

    render: function () {
        this.$el.html( this.template( this.serializeData() ) );
        this.didMount();
        return this;
    },

    serializeData: function () {
        var isNew = false,
            hasPromo,
            promo;

        if ( this.activeSku ) {
            isNew = this.activeSku.get( 'isNew' );
            promo = this.activeSku.getPromotion();
            if ( promo ) {
                hasPromo = true;
            }
        }

        return {
            isNew: isNew,
            hasPromo: hasPromo,
            images: this.collection.models,
            fallbackAltText: this.activeSku.get( 'itemName' )
        };
    },

    close: function () {
        this.undelegateEvents();
        this.stopListening( app.mediator );
        this.stopListening( this.collection );
        this.remove();
    }

} );

export default ProductImageModuleView;
